import { fetchFeatureFlags } from '../../../api/fetchers/featureFlags/fetcher';
import type { FeatureConfigList } from '../types';

import type { FeatureServiceFetcher } from './types';

export class PMSFetcher implements FeatureServiceFetcher {
  constructor(
    private JSESSIONID: string,
    private baseUrl: string
  ) {}

  fetch(): Promise<FeatureConfigList> {
    return fetchFeatureFlags({
      url: this.baseUrl,
      JSESSIONID: this.JSESSIONID,
    });
  }
}
